import React, { useState } from "react";
import {
  Container,
  Card,
  CardContent,
  makeStyles,
  Grid,
  Button,
} from "@material-ui/core";
import image1 from "../assets/1.png";
import image2 from "../assets/2.png";
import image3 from "../assets/3.png";
import qrcode from "../assets/navs/qrcode.png";
import generate from "../assets/navs/qrcodeGen.png";
import search from "../assets/navs/search.png";
import analytics from "../assets/navs/analytics.png";
import welcomeGridImg from "../assets/navs/welcomeGrid.png";
import rfid from "../assets/navs/scanrfid2.png";
import Navigation from "./Navigation";
import Alert from "@mui/material/Alert";

const CustomCard = ({ imgSrc, title, description, redirection, onClickFn }) => {
  const classes = useStyles();

  return (
    <>
      {redirection ? (
        //general
        <div
          className={classes.card}
          onClick={() => {
            const action = redirection
              ? (window.location.pathname = redirection)
              : null;
          }}
        >
          <div className={classes.cardImageWrapper}>
            <img src={imgSrc} alt="Card Image" className={classes.cardImg} />
            <div className={classes.cardOverlay}></div>
            <div className={classes.cardShimmer}></div>
          </div>
          <div className={classes.cardContent}>
            <h3 className={classes.cardTitle}>{title}</h3>
            <p className={classes.cardDescription}>{description}</p>
            <div className={classes.cardGlow}></div>
          </div>
        </div>
      ) : (
        //only for reports download
        <div className={classes.card} onClick={onClickFn}>
          <div className={classes.cardImageWrapper}>
            <img src={imgSrc} alt="Card Image" className={classes.cardImg} />
            <div className={classes.cardOverlay}></div>
            <div className={classes.cardShimmer}></div>
          </div>
          <div className={classes.cardContent}>
            <h3 className={classes.cardTitle}>{title}</h3>
            <p className={classes.cardDescription}>{description}</p>
            <div className={classes.cardGlow}></div>
          </div>
        </div>
      )}
    </>
  );
};

const Home = () => {
  const classes = useStyles();
  const [showAlert, setshowAlert] = useState(false);

  const handleAlert = () => {
    setshowAlert(true);
    setTimeout(() => {
      setshowAlert(false);
    }, 5000);
  };

  return (
    <Container className={classes.conatiner}>
      {/* Animated background orbs */}
      <div className={classes.bgOrb1}></div>
      <div className={classes.bgOrb2}></div>
      <div className={classes.bgOrb3}></div>

      <div className={classes.alertWrapper}>
        {showAlert ? (
          <Alert severity="success" className={classes.alertBox}>
            Stay Tuned, Coming Soon!!
          </Alert>
        ) : null}
      </div>
      <Card className={classes.homecard}>
        <CardContent style={{textAlign:"center"}}>
          <Navigation></Navigation>
          <br />
          <br />

          <Grid item xl="auto" lg="auto" md="auto" sm="auto" xs="auto">
            <div className={classes.cardContainer}>
              {/* <CustomCard
                imgSrc={welcomeGridImg}
                title="Welcome Grid"
                redirection="/welcomegrid"
              /> */}
              <CustomCard
                imgSrc={qrcode}
                title="Scan QR Code"
                redirection="/scan"
              />
              <CustomCard
                imgSrc={search}
                title="Search"
                redirection="/search"
                onClickFn={handleAlert}
              />
              <CustomCard
                imgSrc={generate}
                title="Data Upload"
                redirection="/generate"
              />
              {/* <CustomCard
                imgSrc={rfid}
                title="RFID"
                redirection="/rfid"
                onClickFn={() => {
                  document.getElementById("downloadReports").click();
                }}
              /> */}
              <CustomCard
                imgSrc={analytics}
                title="Reports"
                redirection="/analytics"
                onClickFn={() => {
                  document.getElementById("downloadReports").click();
                }}
              />
              
            </div>
          </Grid>
          <br />
          <br />
        </CardContent>
      </Card>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  "@keyframes fadeIn": {
    from: {
      opacity: 0,
      transform: "translateY(28px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  "@keyframes slideDown": {
    from: {
      opacity: 0,
      transform: "translateY(-20px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  "@keyframes orbFloat1": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "33%": { transform: "translate(60px, -80px) scale(1.15)" },
    "66%": { transform: "translate(-40px, 40px) scale(0.9)" },
  },
  "@keyframes orbFloat2": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "33%": { transform: "translate(-70px, 50px) scale(1.1)" },
    "66%": { transform: "translate(50px, -60px) scale(0.95)" },
  },
  "@keyframes orbFloat3": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(40px, 60px) scale(1.2)" },
  },
  "@keyframes shimmer": {
    "0%": { transform: "translateX(-120%) skewX(-15deg)" },
    "100%": { transform: "translateX(220%) skewX(-15deg)" },
  },
  "@keyframes pulseGlow": {
    "0%, 100%": { opacity: 0.4, transform: "scaleX(0.8)" },
    "50%": { opacity: 0.9, transform: "scaleX(1.1)" },
  },
  "@keyframes borderSpin": {
    "0%": { backgroundPosition: "0% 50%" },
    "50%": { backgroundPosition: "100% 50%" },
    "100%": { backgroundPosition: "0% 50%" },
  },
  "@keyframes alertBounce": {
    "0%": { opacity: 0, transform: "translateX(-50%) translateY(-30px) scale(0.9)" },
    "60%": { transform: "translateX(-50%) translateY(4px) scale(1.02)" },
    "100%": { opacity: 1, transform: "translateX(-50%) translateY(0) scale(1)" },
  },

  conatiner: {
    background: "linear-gradient(160deg, #0a0a0f 0%, #12121a 40%, #0d0d15 100%)",
    height: "100vh",
    width: "100vw",
    maxWidth: "100vw",
    position: "relative",
    padding: "0 !important",
    overflow: "hidden",
  },

  /* Floating ambient orbs */
  bgOrb1: {
    position: "fixed",
    top: "-15%",
    left: "-10%",
    width: 600,
    height: 600,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(232, 27, 35, 0.18) 0%, rgba(232, 27, 35, 0.04) 50%, transparent 70%)",
    animation: "$orbFloat1 12s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
    filter: "blur(8px)",
  },
  bgOrb2: {
    position: "fixed",
    bottom: "-20%",
    right: "-10%",
    width: 700,
    height: 700,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(180, 10, 18, 0.14) 0%, rgba(120, 0, 10, 0.05) 50%, transparent 70%)",
    animation: "$orbFloat2 16s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
    filter: "blur(12px)",
  },
  bgOrb3: {
    position: "fixed",
    top: "40%",
    left: "30%",
    width: 400,
    height: 400,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(255, 80, 80, 0.08) 0%, transparent 70%)",
    animation: "$orbFloat3 20s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
    filter: "blur(20px)",
  },

  homecard: {
    background: "rgba(14, 14, 20, 0.85)",
    backdropFilter: "blur(30px)",
    WebkitBackdropFilter: "blur(30px)",
    border: "1px solid rgba(255, 255, 255, 0.06)",
    boxShadow: "0 8px 64px 0 rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255,255,255,0.05)",
    height: "99.6%",
    margin: "0 !important",
    padding: "0 !important",
    overflowY: "scroll",
    position: "relative",
    zIndex: 1,
    animation: "$fadeIn 0.7s cubic-bezier(0.22, 1, 0.36, 1)",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(255, 255, 255, 0.03)",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "linear-gradient(180deg, #e81b23 0%, #7b0008 100%)",
      borderRadius: "10px",
    },
  },

  card: {
    cursor: "pointer",
    // Responsive fluid sizing: grows/shrinks between 140px and 265px
    flex: "1 1 220px",
    minWidth: 140,
    maxWidth: 265,
    border: "1px solid rgba(255, 255, 255, 0.08)",
    borderRadius: 20,
    overflow: "hidden",
    color: "#fff",
    backgroundColor: "#111118",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.6), 0 1px 0 rgba(255,255,255,0.05) inset",
    transition: "transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.4s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.3s ease",
    animation: "$fadeIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) backwards",
    willChange: "transform",
    position: "relative",
    // On mobile: 2 cards per row
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 calc(50% - 12px)",
      minWidth: "calc(50% - 12px)",
      maxWidth: "calc(50% - 12px)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: 20,
      padding: "1px",
      background: "linear-gradient(135deg, rgba(232,27,35,0) 0%, rgba(232,27,35,0) 100%)",
      WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
      transition: "background 0.4s ease",
      pointerEvents: "none",
    },
    "&:nth-child(1)": { animationDelay: "0.1s" },
    "&:nth-child(2)": { animationDelay: "0.2s" },
    "&:nth-child(3)": { animationDelay: "0.3s" },
    "&:nth-child(4)": { animationDelay: "0.4s" },
    "&:hover": {
      transform: "translateY(-12px) scale(1.02)",
      boxShadow: "0 20px 60px rgba(232, 27, 35, 0.35), 0 8px 24px rgba(0,0,0,0.5), 0 0 0 1px rgba(232,27,35,0.4)",
      borderColor: "rgba(232, 27, 35, 0.5)",
      "& $cardOverlay": {
        opacity: 1,
      },
      "& $cardImg": {
        transform: "scale(1.12)",
        filter: "brightness(1.1) saturate(1.2)",
      },
      "& $cardTitle": {
        color: "#ff4d55",
        textShadow: "0 0 20px rgba(232, 27, 35, 0.8)",
      },
      "& $cardShimmer": {
        animation: "$shimmer 0.7s ease forwards",
      },
      "& $cardGlow": {
        animation: "$pulseGlow 1.5s ease-in-out infinite",
      },
    },
  },

  cardContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: theme.spacing(4),
    padding: theme.spacing(4),
    // Tablet (sm): tighten gap and padding slightly
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(2.5),
      padding: theme.spacing(3),
    },
    // Mobile (xs): 2-column grid layout, compact spacing
    [theme.breakpoints.down("xs")]: {
      gap: theme.spacing(1.5),
      padding: theme.spacing(2),
    },
  },

  cardImageWrapper: {
    position: "relative",
    overflow: "hidden",
    // Desktop: 300px; tablet: 250px; mobile: 200px
    height: 300,
    [theme.breakpoints.down("sm")]: {
      height: 250,
    },
    [theme.breakpoints.down("xs")]: {
      height: 200,
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(180deg, #1a1a24 0%, #0e0e16 100%)",
  },

  cardImg: {
    width: "80%",
    objectFit: "contain",
    transition: "transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), filter 0.4s ease",
    willChange: "transform",
    filter: "brightness(0.95) contrast(1.05)",
  },

  cardOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(135deg, rgba(232, 27, 35, 0.0) 0%, rgba(232, 27, 35, 0.25) 100%)",
    opacity: 0,
    transition: "opacity 0.4s ease",
    pointerEvents: "none",
  },

  cardShimmer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "50%",
    height: "100%",
    background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.12) 50%, transparent 100%)",
    transform: "translateX(-120%) skewX(-15deg)",
    pointerEvents: "none",
  },

  cardContent: {
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5),
    },
    background: "transparent",
    position: "relative",
    overflow: "hidden",
  },

  cardGlow: {
    position: "absolute",
    bottom: 0,
    left: "10%",
    width: "80%",
    height: "2px",
    background: "linear-gradient(90deg, transparent, #e81b23, transparent)",
    borderRadius: "50%",
    opacity: 0,
  },
  
  cardTitle: {
    marginTop: 0,
    marginBottom: theme.spacing(1),
    fontSize: "1.4rem",
    fontWeight: 700,
    color: "#f0f0f5",
    letterSpacing: "0.02em",
    transition: "color 0.3s ease, text-shadow 0.3s ease",
    // Tablet
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.15rem",
    },
    // Mobile
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.95rem",
      marginBottom: theme.spacing(0.5),
    },
  },
  
  cardDescription: {
    marginTop: 0,
    color: "rgba(180, 180, 200, 0.6)",
    lineHeight: 1.6,
    fontSize: "0.875rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.75rem",
      lineHeight: 1.4,
    },
  },

  title: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    background: "linear-gradient(135deg, #0e0e16 0%, #12121e 100%)",
    color: "#fff",
    padding: 20,
    marginBottom: 10,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.4)",
    animation: "$slideDown 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
  },

  btn: {
    marginTop: 10,
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },

  searchTextField: {
    width: "80%",
  },

  alertWrapper: {
    position: "fixed",
    top: 20,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 9999,
    width: "90%",
    maxWidth: 600,
  },

  alertBox: {
    animation: "$alertBounce 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards",
    boxShadow: "0 8px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(232,27,35,0.3)",
    borderRadius: 12,
    fontSize: "1rem",
    fontWeight: 600,
    background: "linear-gradient(135deg, #1a2a1a 0%, #0f1f0f 100%)",
    border: "1px solid rgba(50, 200, 80, 0.3)",
  },
}));

export default Home;